import React  from "react";

const Card =() =>{
return <><div className="course-card ">
<div className="course-status"></div>
<div className="course-badge"></div>
<div className="imagepallet"></div>
              <div className="create-card-icon">
              

                     </div> <div className="create-card-text">
                  <div className="create-card-title"> 
                 
               
                  </div> 
                  <div className="create-card-description">
                    
                  </div> 
              </div> 
              
              <div  className=" item-card  add-cursor" >
          <div  className="item-icon">
          
         </div>
          <div  className="item-text">
         <div className="text-line" ></div>
          </div>
      </div>
             <div className="course-tabs-outer">
             <div className="text-linetw"></div>   
             <div className="text-linetw"></div> 
             <div className="text-linetw"></div>   
             <div className="text-linetw"></div> 
             </div>
             <div className="course-bottom">
            
<div className="imagetw">
              
              </div>
              <div className="imagetw">
             <div className=""> </div>
              </div> 
             </div>
             
              </div></>
}

export default Card;